import React from 'react';
import './App.css';
import { Anchor, Box, Image, Main, Text } from 'grommet';
import {
    Outlet,
    redirect,
    useLoaderData,
    useNavigate,
    useParams,
} from 'react-router-dom';
import {
    clearUserData,
    hasToken,
    hasUserId,
    UserService,
    AppConstants,
} from '@enrich/shared-lib';

export const App = () => {
    const navigate = useNavigate();
    const { companySlug } = useParams();
    const user = useLoaderData();

    const logout = () => {
        clearUserData();
        navigate(`/${companySlug}/login`);
    };

    return (
        <Main>
            <Box
                align="center"
                background="enrich-blue"
                direction="row"
                justify="between"
                pad={{ top: 'large', bottom: 'medium', horizontal: 'large' }}>
                <Text>Enrich Scholars</Text>
                <Box align="center" direction="row" gap="small">
                    {user?.company?.logo?.url && (
                        <Image
                            src={`${user.company.logo.url}`}
                            alt={user.company.name}
                            height="40px"
                            fit="contain"
                        />
                    )}
                    <Text weight="bold">
                        {user?.company?.name || companySlug} Portal
                    </Text>
                </Box>
            </Box>
            <Box
                background="enrich-grey"
                pad={{ vertical: 'small', horizontal: 'medium' }}
                direction="row"
                gap="medium"
                justify="between">
                <Box direction="row" gap="medium">
                    <Anchor
                        href={`/${companySlug}/dashboard`}
                        label="Dashboard"
                    />
                    <Anchor href={`/${companySlug}/jobs`} label="Jobs" />
                    <Anchor
                        href={`/${companySlug}/candidates`}
                        label="Candidates"
                    />
                    <Anchor
                        href={`/${companySlug}/sessions`}
                        label="Sessions"
                    />
                </Box>
                <Anchor onClick={logout} label="Log out" />
            </Box>

            <Outlet context={user} />
        </Main>
    );
};

export async function loader({ params }) {
    const { companySlug } = params;

    if (!hasToken() || !hasUserId()) {
        clearUserData();
        return redirect(`/${companySlug}/login`);
    }

    const userId = localStorage.getItem(AppConstants.cacheKeys.userId);
    try {
        const user = await new UserService().getUser(userId);

        const userCompanySlug = user?.company?.slug;
        if (!userCompanySlug || userCompanySlug !== companySlug) {
            clearUserData();
            return redirect(`/${companySlug}/login`);
        }

        if (!user.tempPasswordChanged) {
            return redirect(`/${companySlug}/change-password`);
        }

        return user;
    } catch {
        clearUserData();
        return redirect(`/${companySlug}/login`);
    }
}
